import { format, sub, lastDayOfMonth } from 'date-fns'

export const getPrevMonthDuration = (date: Date) => {
  const prevMonthDate = sub(date, { months: 1 })

  const month = format(prevMonthDate, 'MMM')
  const year = prevMonthDate.getFullYear()
  const lastDay = lastDayOfMonth(prevMonthDate)

  return {
    firstDay: `${format(prevMonthDate.getDate(), 'do')} ${month} ${year}`,
    lastDay: `${format(lastDay, 'do')} ${month} ${year}`,
  }
}
